export const formatMoney = (value: number | string, unit = "￥ ") => {
  if (typeof value === "string") {
    value = parseInt(value);
  }

  if (isNaN(value)) {
    return "0円";
  }

  return `${unit}${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
};
